import React from "react"
import { Active, DndContext, Over, UniqueIdentifier } from "@dnd-kit/core"
import { SortableContext, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable"
import { t } from "ttag"

import { ThemeQuestionWithTheme } from "features/Surveys/CustomSurveys/models"
import { SortableQuestion } from "./components"
import * as Styles from "./SelectedQuestionsSection.styles"

export const SelectedQuestionsSection: React.FC<SelectedQuestionsSectionProps> = (props) => {
  return (
    <Styles.ChoosenQuestionListContainer>
      {props.questions.length === 0
        ? (
          <Styles.EmptyList>
            {t`No questions selected at the moment`}
          </Styles.EmptyList>
        )
        : (
          <Styles.Container>
            <Styles.SectionTitle>
              {t`Selected questions` + ` (${props.questions.length})`}
            </Styles.SectionTitle>
            <Styles.Questions>
              <DndContext onDragEnd={({ active, over }) => reorderQuestions(props.questions, active, over)}>
                <SortableContext
                  disabled={props.isReadOnly}
                  items={props.questions}
                  strategy={verticalListSortingStrategy}
                >
                  {props.questions.map((question, questionIndex) => (
                    <SortableQuestion
                      key={question.id}
                      question={question}
                      questionIndex={questionIndex}
                      onRemove={() => props.onRemoveQuestion(questionIndex)}
                      isReadOnly={props.isReadOnly}
                    />
                  ))}
                </SortableContext>
              </DndContext>
            </Styles.Questions>
          </Styles.Container>
        )
      }
    </Styles.ChoosenQuestionListContainer>
  )

  function getIndex(items: ThemeQuestionWithTheme[], id: UniqueIdentifier): number {
    return items.findIndex((item) => item.id === id)
  }

  function reorderQuestions(
    questions: ThemeQuestionWithTheme[],
    questionBeingDragged: Active,
    questionBeingDraggedOver: Over | null,
  ): void {
    if (!questionBeingDraggedOver) {
      return
    }

    const questionDraggedIndex = getIndex(questions, questionBeingDragged.id)
    const questionDraggedOverIndex = getIndex(questions, questionBeingDraggedOver.id)

    if (questionDraggedIndex !== questionDraggedOverIndex) {
      const newQuestions = arrayMove(questions, questionDraggedIndex, questionDraggedOverIndex)
      props.onQuestionsReorder(newQuestions)
    }
  }
}

interface SelectedQuestionsSectionProps {
  questions: ThemeQuestionWithTheme[],
  onRemoveQuestion: (questionIndex: number) => void,
  isReadOnly: boolean,
  onQuestionsReorder: (questions: ThemeQuestionWithTheme[]) => void,
}
